import { UNKNOWN_LIBRARY } from '@/core/const/installation.const'
import type { GcgNames } from '@/core/types/installation.type'
import type { LibraryData } from '@/core/types/library.type'
import { buildGcgNames } from '@/core/utils/installation'

export interface GcgPlaceholderInput {
  selectedTechnology?: string
  libraryData?: LibraryData
}

export const computeGcgNames = ({ selectedTechnology, libraryData }: GcgPlaceholderInput): GcgNames =>
  buildGcgNames({
    sourceRuntime: libraryData?.runtimeName,
    libraryName: libraryData?.name ?? UNKNOWN_LIBRARY,
    libraryNamespace: libraryData?.namespace,
    consumerTechnology: selectedTechnology ?? '',
  })

export const toGcgPlaceholders = (names: GcgNames): Record<string, string> => ({
  graftName: names.graftName,
  graftConfigEnvVarName: names.graftConfigEnvVarName,
  packageNamespace: names.packageNamespace,
  publishId: names.publishId,
  mavenGroupId: names.mavenGroupId,
  mavenArtifactId: names.mavenArtifactId,
  phpNamespace: names.phpNamespace,
  rubyRequirePath: names.rubyRequirePath,
  normalizedLibraryName: names.normalizedLibraryName,
  repository: names.repository,
  pythonModule: names.pythonModule,
})
